module.exports = __webpack_public_path__ + "static/media/canReverseBadInjury.200b7bcc.mp3";